import React from 'react';

export interface DoctorClinicLabelProps {
  clinicName?: string | null;
  doctorName?: string | null;
  fallbackName?: string | null;
  className?: string;
  clinicClassName?: string;
  doctorClassName?: string;
}

const isGenericVendorFallback = (value: string): boolean =>
  /^Vendor [a-f0-9-]{8}/i.test(value);

export const DoctorClinicLabel: React.FC<DoctorClinicLabelProps> = ({
  clinicName,
  doctorName,
  fallbackName,
  className = '',
  clinicClassName = 'font-medium text-gray-900 dark:text-white',
  doctorClassName = 'text-xs text-gray-500 dark:text-gray-400',
}) => {
  const clinic = (clinicName || '').trim();
  const doctor = (doctorName || '').trim();
  let fallback = (fallbackName || '').trim();
  if (isGenericVendorFallback(fallback)) {
    fallback = '';
  }

  const primary = clinic || doctor || fallback || 'N/A';
  const showDoctorSecondary = Boolean(clinic && doctor);

  return (
    <div className={`text-sm ${className}`}>
      <div className={clinicClassName}>{primary}</div>
      {showDoctorSecondary && <div className={doctorClassName}>{doctor}</div>}
    </div>
  );
};

export const isDoctorVendorType = (vendorType?: string | null): boolean =>
  String(vendorType || '').toUpperCase() === 'DOCTOR';

export const resolveDoctorPrimaryName = (
  clinicName?: string | null,
  doctorName?: string | null,
  fallbackName?: string | null
): string => {
  const clinic = (clinicName || '').trim();
  const doctor = (doctorName || '').trim();
  let fallback = (fallbackName || '').trim();
  if (isGenericVendorFallback(fallback)) {
    fallback = '';
  }
  return clinic || doctor || fallback || 'N/A';
};
